import { StyledTooltip } from './StyledTooltip';

export default StyledTooltip;
